import React from 'react'

const Footer = () => {
  return (
    <div className="flex justiy-center items-center h-15 bg-black text-white">
      <p>Copyright © 2021 EGG All rights reserved.</p>
    </div>
  );
}

export default Footer
